// extracted by mini-css-extract-plugin
module.exports = {"avatar":"dJLi8oXn H6On8Sx7 qCnGG6r0 _1X0dhxAa GUTMtdJ8","avatarLarge":"_2x5u4BSw _1_WwV6pt"};